<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="newsPageView" :model="formData" class="full-width-input" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="信息类别" prop="SysNews.infoType">
            <el-radio-group class="input-item" v-model="formData.SysNews.infoType"
              @change="onInfoTypeValueChange"
            >
              <el-radio v-for="item in newsPageView.infoType.impl.dropdownList" :key="item.id"
                :label="item.id"
              >
                {{item.name}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="主题名称" prop="SysNews.subjectName">
            <el-input class="input-item" v-model="formData.SysNews.subjectName"
              :clearable="true" placeholder="请输入主题名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="内容" prop="SysNews.contentInfo">
            <rich-editor ref="contentInfo" class="input-item" v-model="formData.SysNews.contentInfo" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="封面" prop="SysNews.coverImages">
            <template >
              <el-image v-for="item in parseUploadData(formData.SysNews.coverImages, {id: formData.SysNews.id,
                  fieldName: 'coverImages', asImage: true})"
                        :preview-src-list="getPictureList(formData.SysNews.coverImages, {id: formData.SysNews.id, fieldName: 'coverImages', asImage: true})"
                        class="table-cell-image" :key="item.url" :src="item.url" fit="scale-down">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="首页展示" prop="SysNews.indexFlag">

            <span class="input-item input-label" >{{(formData.SysNews.indexFlagDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="附件" prop="SysNews.attachedFiles">
            <div v-if="newsPageView.attachedFiles.impl.fileList && newsPageView.attachedFiles.impl.fileList[0] != null"
                 style="position: relative">
              <div v-for="(item) in newsPageView.attachedFiles.impl.fileList" :key="item.url"
                   style="display:flex;margin-top: 5px;">
                <div> {{item.name}}</div>
                <div style="margin-left: 15px;display: inline-flex">

                  <el-button type="primary" @click="downloadFile(item.url, item.name)">下载</el-button>
                  <el-button type="primary" @click="previewFile(item.url, item.filename)">预览</el-button>
                </div>

              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { SysNewsController, DictionaryController } from '@/api';

export default {
  name: 'newsPageView',
  props: {
    id: {
      default: undefined
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      formData: {
        SysNews: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          infoType: undefined,
          subjectName: undefined,
          contentInfo: undefined,
          auditStatus: undefined,
          upFlag: undefined,
          attachedFiles: undefined,
          isDatasourceInit: false
        }
      },
      newsPageView: {
        formFilter: {
        },
        formFilterCopy: {
        },
        infoType: {
          impl: new DropdownWidget(this.loadInfoTypeDropdownList)
        },
        attachedFiles: {
          impl: new UploadWidget(5)
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    /**
     * 信息类别下拉数据获取函数
     */
    loadInfoTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictInfoTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 信息类别选中值改变
     */
    onInfoTypeValueChange (value) {
    },
    /**
     * 更新查看信息详情
     */
    refreshNewsPageView (reloadData = false) {
      this.loadSysNewsData().then(res => {
        if (!this.newsPageView.isInit) {
          // 初始化下拉数据
          this.newsPageView.infoType.impl.onVisibleChange(true).catch(e => {});
        }
        this.newsPageView.isInit = true;
      }).catch(e => {});
    },
    onResume () {
      this.refreshNewsPageView(true);
    },
    /**
     * 获取新闻通告表详细信息
     */
    loadSysNewsData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.SysNews.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          SysNewsController.view(this, params).then(res => {
            this.formData.SysNews = {...res.data, isDatasourceInit: true};
            this.newsPageView.infoType.impl.onVisibleChange(true).catch(e => {});
            let attachedFilesDownloadParams = {
              id: this.formData.SysNews.id,
              fieldName: 'attachedFiles',
              asImage: false
            }
            this.newsPageView.attachedFiles.impl.fileList = this.parseUploadData(this.formData.SysNews.attachedFiles, attachedFilesDownloadParams);
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.SysNews.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 附件上传成功
     */
    onAttachedFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.newsPageView.attachedFiles.impl.onFileChange(file, fileList);
        this.formData.SysNews.attachedFiles = this.fileListToJson(this.newsPageView.attachedFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除附件
     */
    onAttachedFilesRemoveFile (file, fileList) {
      this.newsPageView.attachedFiles.impl.onFileChange(file, fileList);
      this.formData.SysNews.attachedFiles = this.fileListToJson(this.newsPageView.attachedFiles.impl.fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        SysNews: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          infoType: undefined,
          subjectName: undefined,
          contentInfo: undefined,
          auditStatus: undefined,
          upFlag: undefined,
          attachedFiles: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshNewsPageView();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
